export const product_list = () => ({ type: "Product_list" });
export const set_product_list = (payload) => ({
  type: "Product_list",
  payload,
});
export const toogleHeader_data = () => ({ type: "toggle_header" });
export const setToogleHeader = (payload) => ({
  type: "toggle_header",
  payload,
});
export const invoicereport_data = () => ({ type: "Invoicereport_Data" });
export const setinvoicereport_data = (payload) => ({
  type: "Invoicereport_Data",
  payload,
});
export const customer_data = () => ({ type: "customer_data" });
export const setcustomer_data = (payload) => ({
  type: "customer_data",
  payload,
});
export const userlist_data = () => ({ type: "Userlist_data" });
export const setuserlist_data = (payload) => ({
  type: "Userlist_data",
  payload,
});
export const rolesandpermission_data = () => ({
  type: "Rolesandpermission_data",
});
export const setrolesandpermission_data = (payload) => ({
  type: "Rolesandpermission_data",
  payload,
});
export const deleteaccount_data = () => ({ type: "Deleteaccount_data" });
export const setdeleteaccount_data = (payload) => ({
  type: "Deleteaccount_data",
  payload,
});
export const lowstock_data = () => ({ type: "Lowstock_data" });
export const setlowstock_data = (payload) => ({
  type: "Lowstock_data",
  payload,
});
export const categotylist_data = () => ({ type: "Categotylist_data" });
export const setcategotylist_data = (payload) => ({
  type: "Categotylist_data",
  payload,
});
export const setLayoutChange = (payload) => ({
  type: "Layoutstyle_data",
  payload,
});
